
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Prefer environment-provided configuration; fall back to sensible defaults based on hostname
const envSupabaseUrl =
  (import.meta as any)?.env?.VITE_SUPABASE_URL ||
  (import.meta as any)?.env?.SUPABASE_URL ||
  '';
const envSupabaseAnonKey =
  (import.meta as any)?.env?.VITE_SUPABASE_ANON_KEY ||
  (import.meta as any)?.env?.SUPABASE_ANON_KEY ||
  '';

// Choose defaults by hostname if env vars are not provided
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isDevelopLikeHost = hostname === 'localhost' ||
                          hostname === '127.0.0.1' ||
                          hostname.includes('lovable.app') ||
                          hostname.includes('preview--');

const defaultSupabaseUrl = isDevelopLikeHost
  ? 'https://gczsabcniwluavnsmtzk.supabase.co'  // ✅ DEVELOP Supabase
  : 'https://jghjbjqdoassylgqdkgy.supabase.co';  // ✅ PRODUCTION (ChronoCal main)

// Note: keep anon keys inline to avoid blocking local dev if env is missing
const defaultSupabaseAnonKey = isDevelopLikeHost
  ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdjenNhYmNuaXdsdWF2bnNtdHprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3OTkzNzQsImV4cCI6MjA2ODM3NTM3NH0.DnIMepn0EoeIQNw5KhVXE3OGaC1KWuKaqyKD3P-mLqo'  // ✅ DEVELOP Supabase anon key
  : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpnaGpianFkb2Fzc3lsZ3Fka2d5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUxNjM1OTUsImV4cCI6MjA2MDczOTU5NX0.n7VAtN8KKtQ3JrqrLxCC2RqPyseUqTe-LB28T3qVRmk';  // ✅ PRODUCTION (ChronoCal main)

const supabaseUrl: string = envSupabaseUrl || defaultSupabaseUrl;
const supabaseAnonKey: string = envSupabaseAnonKey || defaultSupabaseAnonKey;

// Debug: Log which configuration is used
console.log('🔍 Supabase Client Debug:');
console.log('Using env vars:', Boolean(envSupabaseUrl && envSupabaseAnonKey));
console.log('Resolved SUPABASE_URL:', supabaseUrl);
console.log('Resolved SUPABASE_ANON_KEY:', supabaseAnonKey ? '✅ Present' : '❌ Missing');

// Derive a stable, project-specific storage key to avoid collisions with
// other Supabase clients that may exist in the same browser context
let projectRef = 'unknown';
try {
  const host = new URL(supabaseUrl).host; // e.g., gczsabcniwluavnsmtzk.supabase.co
  projectRef = host.split('.')[0];
} catch (e) {
  // no-op
}

// Singleton client instance to prevent multiple GoTrueClient instances
let clientInstance: ReturnType<typeof createClient<Database>> | null = null;

const getSupabaseClient = () => {
  if (!clientInstance) {
    clientInstance = createClient<Database>(supabaseUrl, supabaseAnonKey, {
      auth: {
        storageKey: `cc-${projectRef}-auth`,
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return clientInstance;
};

export const supabase = getSupabaseClient();

// Expose for quick debugging in the console
if (typeof window !== 'undefined') {
  (window as any).__SUPABASE_URL__ = supabaseUrl;
  (window as any).__SUPABASE_PROJECT__ = projectRef;
}
